// extracted by mini-css-extract-plugin
export default {"field":"UserPasswordEditStep_field__Hm1re","text":"UserPasswordEditStep_text__bCLOO"};